import { localstorage } from "@ajx-common/trth-web-common";
import localstorageKeys from "@/config/localstorage.keys";
/**
 * 用户身份鉴权相关工具
 */

// 设置token
export function setToken(token) {
  return localstorage.save(localstorageKeys.TOKEN, token);
}

// 获取token
export function getToken() {
  return localstorage.get(localstorageKeys.TOKEN) || "";
}

// 设置租户id
export function setTenantId(tenantId) {
  return localstorage.save(localstorageKeys.TENANT_ID, tenantId);
}

// 获取租户id
export function getTenantId() {
  return localstorage.get(localstorageKeys.TENANT_ID) || "";
}

// 设置bid
export function setBid(bid) {
  return localstorage.save(localstorageKeys.BID, bid);
}

// 获取bid
export function getBid() {
  return localstorage.get(localstorageKeys.BID) || "";
}
